import React from 'react'
import Endpoint from './Endpoint'

import { Button } from '@govtechsg/sgds-react/Button'

import arrowleft from '../assets/icons/arrow-left.svg'
import arrowright from '../assets/icons/arrow-right.svg'

const AuthenticationComponent = ({ clickButton, endpointreturn }) => {
   return (
     <>
       <div className="om-authentication-section">
         <h1>Authentication</h1>
         <div>
           <p className="om-desc">
             {/* This API authenticates users' credentials (email and password) as<br />
						a POST request body to generate an access token and its expiry<br />
						timestamp is in JSON format. The token is not required for the <strong className='slate-bold'>Static Map</strong> services. */}
             This API authenticates users&#39; credentials (email and password)
             as a POST request body to generate an access token.{" "}
             <i>The token is not required for the map services.</i>
           </p>
           <p>
             Each token is valid for 3 days. Its expiry timestamp is in UNIX
             format. When it expires, the user needs to re-authenticate with the
             same credentials. The token does not auto renew when it expires.
           </p>
           <p>
             <b>
               Developers are strongly encourage to securely store sensitive
               data such as API keys and passwords in your application. Do not
               pass the authentication data in plain text.
             </b>
           </p>
           {/* <p className='om-desc'>
						Each token is <em className='slate-italic'><strong className='slate-bold'>valid for 3 days</strong></em>. When it expires, user needs to re-<br />
						authenticate with the same credentials. The token does not auto<br />
						renew when it expires.
					</p> */}
         </div>
         <div className="om-authentication-wrapper">
           <div className="om-authentication">
             <h4 className="om-authentication-header">BODY PARAMETERS</h4>
           </div>
           <div className="om-authentication-items">
             <div className="om-authentication-item">
               <div className="label-method">
                 email
                 <span className="label-type">string</span>
                 <span className="label-required">Required</span>
               </div>
               <div className="om-authentication-desc">
                 <p>Registered email used for OneMap registration</p>
               </div>
             </div>
             <div className="om-authentication-item">
               <div className="label-method">
                 password
                 <span className="label-type">string</span>
                 <span className="label-required">Required</span>
               </div>
               <div className="om-authentication-desc">
                 <p>Password used for OneMap registration</p>
               </div>
             </div>
           </div>
         </div>
         <Endpoint {...endpointreturn("authentication")} />

         <h5 className="om-api-box-header"> Possible Error Responses</h5>
         <p>
           401 - Authentication failed, please contact admin at
           support@onemap.gov.sg
         </p>
         <p>404 - User is not registered in system.</p>
         {/* <p>404 - User is not registered in system.</p> */}
         <p>
           404 - You have to enter a valid email address and valid password to
           generate a token.
         </p>
       </div>
     </>
   ); 
}

export default AuthenticationComponent
